import { type PropertyInterestData } from '@aikoa/common'
import { useTranslations } from '@aikoa/i18n/react'
import { useState } from 'react'
import { View } from 'react-native'
import {
  InterestDetailsView,
  type InterestDetailsViewProps,
} from '~/components/interests/InterestDetailsView'
import {
  InterestFilterSummary,
  type InterestFilterSummaryContext,
} from '~/components/interests/InterestFilterSummary'
import { Button } from '~/components/ui/button'
import { cn } from '~/lib/utils'

export function ToggleableInterestDisplay({
  interest,
  className,
  wrapperClassName,
  defaultDetailed = false,
  valueClassName,
  valueChildren,
  context = 'own',
}: {
  interest: PropertyInterestData
  className?: string
  wrapperClassName?: string
  defaultDetailed?: boolean
  valueClassName?: string
  valueChildren?: InterestDetailsViewProps['valueChildren']
  context?: InterestFilterSummaryContext
}) {
  const { t } = useTranslations('interest')
  const [showFullInterest, setShowFullInterest] = useState(defaultDetailed)

  return (
    <View className={cn('group/interest gap-4', wrapperClassName)} aria-expanded={showFullInterest}>
      {!showFullInterest ? (
        <InterestFilterSummary
          key="interest-filter-summary"
          filters={interest?.filters ?? {}}
          locations={interest?.locations ?? []}
          className={cn('flex-wrap rounded-xl border border-border p-4', className)}
          displayOnly
          description={interest?.description ?? null}
          context={context}
        />
      ) : (
        <InterestDetailsView
          key="interest-details-view"
          interest={interest}
          className={cn('rounded-xl border border-border bg-white', className)}
          valueClassName={valueClassName}
          valueChildren={valueChildren}
        />
      )}
      <Button
        variant="outline"
        size="sm"
        className="self-center text-secondary"
        onPress={() => setShowFullInterest((current) => !current)}>
        {showFullInterest ? t(($) => $.labels.hideDetailed) : t(($) => $.labels.showDetailed)}
      </Button>
    </View>
  )
}
